<script>
	import { ShareIcon } from 'svelte-feather-icons'
	import { getContext, onMount } from 'svelte'
	import notyf from '../utils/notyf'
	import AsyncButton from '../components/AsyncButton.svelte'
	import { getMap } from '../map'
  import { doRawFetch } from '../api';

	let isMenuOpen = false

	const flightContext = getContext('flight')
	let flight
	let flightStore

	onMount(() => {
		flight = flightContext.get()
		flightStore = flight.liveServerStateStore
	})

	function clickOutside(node, { enabled: initialEnabled, cb }) {
    const handleOutsideClick = ({ target }) => {
      if (!node.contains(target)) {
        cb();
      }
    };

    function update({enabled}) {
      if (enabled) {
        window.addEventListener('click', handleOutsideClick);
      } else {
        window.removeEventListener('click', handleOutsideClick);
      }
    }

    update({ enabled: initialEnabled });
    return {
      update,
      destroy() {
        window.removeEventListener( 'click', handleOutsideClick );
      }
    };
  }

	async function copy(include = {}) {
		try {
			let url = location.protocol + '//' + location.host + '/flights/' + flight.serverState.id
			if (include.time) {
				url += '?t=' + flight.replayInfo.currentTimestamp.toFixed(0)
			}
			if (include.location) {
				const center = getMap().getCenter()
				const zoom = getMap().getZoom()
				url += `&lat=${center.lat.toFixed(5)}&lng=${center.lng.toFixed(5)}&z=${zoom}`
			}
			await navigator.clipboard.writeText(url)
			notyf.success('Copied Guest URL')
		} catch (error) {
			notyf.error(error.message)
		}
	}

	async function getGuestLink() {
		try {
			const hash = await doRawFetch(`guest/${flight.flightId}/link`)
			let url = `${location.protocol}//${location.host}/guest/${flight.flightId}?a=${(await hash.text())}`
			await navigator.clipboard.writeText(url)
		} catch (E) {
			notyf.error(E.message)
		}
	}
</script>

{#if !(flight?.isGuest)}
<div class="viewLink" use:clickOutside={{ enabled: isMenuOpen, cb: () => isMenuOpen = false }} >
	<div class="shareButton" on:click={() => isMenuOpen = !isMenuOpen}>
		<ShareIcon />
	</div>
	{#if isMenuOpen} 
		<div class="menu">
			<AsyncButton handler={() => copy()}>Copy Flight Link</AsyncButton>
			<AsyncButton handler={() => getGuestLink()}>Copy Guest Link</AsyncButton>
			<AsyncButton handler={() => copy({ time: true })} disabled={!$flightStore.startedTime}>Copy at Time</AsyncButton>
			<AsyncButton handler={() => copy({ time: true, location: true })} disabled={!$flightStore.startedTime}>Copy at Time and Location</AsyncButton>
		</div>
	{/if}
</div>
{/if}

<style>
	.viewLink {
		position: absolute;
		/* Will center on ReplayBar (58px) while keeping it square */
		bottom: calc((58px - 44px)/2 + 32px);
		left: 10px;
		border-radius: 12px;
		background-color: rgb(37, 37, 37, 0.9);
		color: white;
		cursor: pointer;
	}
	.shareButton {
		width: 44px;
		height: 44px;
		display: grid;
		align-items: center;
		justify-content: center;

	}

	.menu {
		background-color: rgb(37,37,37);
		position: absolute;
		left: 0;
		border-radius: 12px;
		bottom: 44px;
		color: white;
		z-index: 5;
		padding: 10px;
		width: 300px;
		border: 1px solid white;
	}

	.menu > :global(*) {
		margin: 8px 0;
	}
</style>